<form [formGroup]="formGroup()">
  <app-validated-number-input
    [label]="translationKey + 'nominalInterestRate'"
    inputFormControlName="nominalInterestRate"
    [inputFormControl]="formGroup().controls.nominalInterestRate"
  />

  <app-validated-date-picker
    [label]="translationKey + 'startOfPayingInterest'"
    inputFormControlName="startOfPayingInterest"
    [inputFormControl]="formGroup().controls.startOfPayingInterest"
    [disabled]="disabled()"
  />

  <app-validated-dropdown
    [label]="translationKey + 'interestPaymentFrequenty'"
    inputFormControlName="interestPaymentFrequenty"
    [inputFormControl]="formGroup().controls.interestPaymentFrequenty"
    [disabled]="disabled()"
    [optionsStamp]="genericProjectStore.loanTypePaymentFrequencyEntities().length"
  >
    @for (freq of genericProjectStore.loanTypePaymentFrequencyEntities();
    track freq.id) {
      <option [value]="freq.id">
        {{ "generic.loanTypePaymentFrequency." + freq.name | translate }}
      </option>
    }
  </app-validated-dropdown>

  <app-validated-date-picker
    [label]="'general.expirationDate'"
    inputFormControlName="dateOfExpiration"
    [inputFormControl]="formGroup().controls.dateOfExpiration"
    [disabled]="disabled()"
  />
  <app-validated-number-input
    [label]="translationKey + 'applicableYield'"
    inputFormControlName="applicableYield"
    [inputFormControl]="formGroup().controls.applicableYield"
  />
</form>
